import { render, staticRenderFns } from "./AdditionalWork.vue?vue&type=template&id=215a1e39&scoped=true"
import script from "./AdditionalWork.vue?vue&type=script&lang=js"
export * from "./AdditionalWork.vue?vue&type=script&lang=js"
import style0 from "./AdditionalWork.vue?vue&type=style&index=0&id=215a1e39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215a1e39",
  null
  
)

export default component.exports